import { type PropType, defineComponent } from 'vue'
import { useStore } from '@/store'
import NewsDetails from '../NewsDetails'
import ImagePreview from '../ImagePreview'

import './style.less'

export default defineComponent({
  props: {
    listItem: {
      type: Object as PropType<NewsItem>,
      default: () => {
        return {}
      }
    },
    recommond: {
      type: Boolean as PropType<boolean>,
    },
    hoverStyle: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    imageWidth: {
      type: Number as PropType<number>,
      default: 120
    },
    imageHeight: {
      type: Number as PropType<number>,
      default: 90
    },
    showPaddingBottom: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    showBottomBorder: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    stopClick: {
      type: Boolean as PropType<boolean>,
    }
  },
  setup(props, { attrs }) {
    const store = useStore()

    const noImageStyle = [ '3', '11' ]

    const classNames = computed(() => {
      return {
        ['hover']: props.hoverStyle,
        ['pb-16px']: props.showPaddingBottom,
        ['main-border-bottom']: props.showBottomBorder
      }
    })

    const openDetails = () => {
      if (props.stopClick) return
      store.global.publicOpenDetails(props.listItem, !!props.recommond)
    }

    return () => {
      return (
        <div class={[ 'news-card_item', classNames.value ]} {...attrs} onClick={() => openDetails()}>
          {
            noImageStyle.includes(props.listItem.appStyle)
              ? (
                <>
                  <div class={[ 'title mb-12px' ]}>
                    {props.listItem.newsTitle}
                  </div>
                  <div class={[ 'description mb-8px' ]}>
                    {props.listItem.newsSummary || props.listItem.newsTitle}
                  </div>
                  <NewsDetails
                    time={props.listItem.publishTime}
                    channelName={props.listItem?.mainChannel?.channelName || ''}
                    record={props.listItem}
                  />
                </>
              )
              : (
                <>
                  <div class={[ 'title mb-12px' ]}>
                    {props.listItem.newsTitle}
                  </div>
                  <div class={'news-image-details'}>
                    <div
                      class={'left'}
                      style={{
                        width: `${props.imageWidth}px`,
                        height: `${props.imageHeight}px`,
                        flex: `0 0 ${props.imageWidth}px`
                      }}
                    >
                      <ImagePreview
                        coverStyle={props.listItem?.coverStyle as any}
                        width={props.imageWidth}
                        height={props.imageHeight}
                        url={props.listItem.imageShow || ''}
                        record={props.listItem}
                      />
                    </div>
                    <div class={'right'}>
                      <div class={[ 'description mb-8px' ]}>
                        {props.listItem.newsSummary || props.listItem.newsTitle}
                      </div>
                      <NewsDetails time={props.listItem.publishTime} channelName={props.listItem?.mainChannel?.channelName || ''} />
                    </div>
                  </div>
                </>
              )
          }
        </div>
      )
    }
  }
})
